import React from 'react';
import cn from 'classnames';

import { CurrencyFormat } from '@lt/components';

import { TEST_ID_PRICE_COMPARER } from './constants';
import styles from './priceComparer.module.css';

interface Props {
  oldPrice: number;
  currentPrice: number;
}

const PriceComparer = ({ oldPrice, currentPrice }: Props) => (
  <div className={styles.container} data-testid={TEST_ID_PRICE_COMPARER}>
    <CurrencyFormat
      className={cn(styles.text, styles.strikethrough)}
      value={oldPrice}
    />
    <div className={styles.text}>→</div>
    <CurrencyFormat className={styles.text} value={currentPrice} />
  </div>
);

export default PriceComparer;
